module.exports = __webpack_public_path__ + "static/media/hide_right.c77c864a.svg";